export default __webpack_public_path__ + "static/media/K2D-Italic.492529df.ttf";